jQuery('input[type="checkbox"]').on('change', function () {
    jQuery(this).parent().removeClass("text-error");
});